/** How a document kind is approved once it is submitted. */
export const ApprovalMode = {
  /** The AI approves what the policy allows; a user approves the rest. */
  AI_AND_USER: 'AI_AND_USER',
  /** A user approves every document; the AI does not run. */
  USER_ONLY: 'USER_ONLY',
  /** No approval: a submitted document is approved at once. */
  SKIPPED: 'SKIPPED'
} as const;

export type ApprovalMode = (typeof ApprovalMode)[keyof typeof ApprovalMode];
